export default [
    {
      name: 'ManageOne789',
      title: 'Manage One 789',
      icon: 'mdi-axis',
    }
]
